module.exports = __webpack_public_path__ + "static/media/wrong.8dc3bd98.png";